import Query from "qpr-base/querybuilder/Query";

export const getValueSettings = (elementId: string) => {
  return Query(elementId)
    .valuesettings()
    .series()
    .attributes("name", "symbol", "description")
    .fetchValues<{
      id: string;
      name: string;
      symbol: string;
      description: string;
    }>();
};
